import { Button, Classes, Dialog, FormGroup, HTMLSelect, InputGroup, } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IAgendamento, newIAgendamento, } from "../../model";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import { format_dia_semana, getDiaSemana } from "../../utils";
import { formatCnpj } from "../../utils";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import { SefaStore } from "../../stores/sefa/SefaStore";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { Pager } from "../utils/Pager";

interface Props {
  open: boolean
  onClose: () => void;
}

@observer
export class AgendamentoSefa extends React.Component<Props, {}> {

  obs = observable({
    agendamento: newIAgendamento() as IAgendamento,
    open_create_agendamento: false
  })

  constructor(props) {
    super(props);
  }

  customSearchAgendamento = (props) => {

    return (
      <SearchField
        className="input-filter input-filter-sefa-agendamento"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );

  };

  handleRowSelect = async (row, checked) => {

    if (checked) {

      this.obs.agendamento.listEmpresas.push(row.cnpj);

    } else {

      let index = this.obs.agendamento.listEmpresas.indexOf(row.cnpj);

      this.obs.agendamento.listEmpresas.splice(index, 1);

    }

  };

  handleRowSelectAll = async (check, row) => {

    if (check) {

      this.obs.agendamento.listEmpresas = row?.map(x => x.cnpj)

    } else {

      this.obs.agendamento.listEmpresas = [];

    }

  };

  handleValidAgendamento() {

    if (this.obs.agendamento.descricao == "") {
      toast.warning('Por favor, preencha a descrição.', {});
      return true
    }

    if (this.obs.agendamento.periodo_selecionado == "") {
      toast.warning('Por favor, selecione um Período de comunicação.', {});
      return true
    }

    if (["semanal", "mensal"].includes(this.obs.agendamento.periodo_selecionado) && this.obs.agendamento.dia == "") {
      toast.warning('Por favor, selecione um dia.', {});
      return true
    }

    if (this.obs.agendamento.listEmpresas.length < 1) {
      toast.warning('Por favor, selecione pelo menos uma empresa.', {});
      return true
    }

    return false

  }

  async handleCreateAgendamento() {

    if (this.handleValidAgendamento()) return

    this.obs.open_create_agendamento = false

    if (this.obs.agendamento.id == "") {

      let data = {
        periodo: this.obs.agendamento.periodo_selecionado,
        dia: this.obs.agendamento.dia,
        empresas: this.obs.agendamento.listEmpresas,
        descricao: this.obs.agendamento.descricao,
        sefa_new: true
      }

      await SefaStore.handleProgramarAgendamento(data)

    } else {

      let data = {
        id: this.obs.agendamento.id,
        periodo: this.obs.agendamento.periodo_selecionado,
        dia: this.obs.agendamento.dia,
        empresas: this.obs.agendamento.listEmpresas,
        descricao: this.obs.agendamento.descricao,
        sefa_new: true
      }

      await SefaStore.handleUpdateAgendamento(data)

    }

    this.obs.agendamento = newIAgendamento()

  }

  async handleCloseAgendamento() {

    this.obs.open_create_agendamento = false

    this.obs.agendamento = newIAgendamento()

  }

  handleDays() {

    const options = []

    for (let i = 1; i <= 31; i++) {

      options.push(<option value={i}>{`${i}`.padStart(2, "0")}</option>)

    }

    return options;

  }

  handlePageAgendamento = async (page: number) => {

    SefaStore.obs.page_agendamentos = page;

    await SefaStore.handleIndexAgendamentos(page);

  };

  render() {

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleRowSelectAll,
      selected: this.obs.agendamento.listEmpresas,
    };

    let empresas = EmpresaStore.sortedEmpresas?.map(emp => {

      return ({
        _id: emp._id,
        razao_social: emp.razao_social,
        cnpj: emp.cnpj,
        cnpj_formated: formatCnpj(emp.cnpj)
      })

    });

    const options_agendamentos = {
      searchField: this.customSearchAgendamento,
    };

    const pad2 = (n) => String(n).padStart(2, "0");

    function addDays(date, days) {
      const d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    }

    function startOfMonth(date) {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    function endOfMonth(date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    function formatWeekdayPt(date) {
      const s = new Intl.DateTimeFormat("pt-BR", { weekday: "long" }).format(date);
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    function getAllWeekdayDatesInMonth(referenceDate, weekdayIndex) {
      const first = startOfMonth(referenceDate);
      const last = endOfMonth(referenceDate);

      // acha a primeira ocorrência do weekday no mês
      const offset = (weekdayIndex - first.getDay() + 7) % 7;
      let cur = addDays(first, offset);

      const dates = [];
      while (cur <= last) {
        dates.push(new Date(cur));
        cur = addDays(cur, 7);
      }
      return dates;
    }

    function buildWeeklyExamples({ weekdayName, referenceDate }) {
      const idx = weekdayName;
      if (idx == null) {
        return {
          title: `Executa toda ${weekdayName}.`,
          lines: [`(Dia da semana inválido: "${weekdayName}")`],
        };
      }

      const dates = getAllWeekdayDatesInMonth(referenceDate, idx);

      const lines = dates.map((runDate) => {
        const periodStart = addDays(runDate, -7);
        const periodEnd = addDays(runDate, -1);

        return `${formatWeekdayPt(runDate)} (${pad2(runDate.getDate())}) → Período do dia ${pad2(periodStart.getDate())} ao dia ${pad2(periodEnd.getDate())}.`;
      });

      return {
        title: `Executa ${format_dia_semana(weekdayName)}. Exemplo:`,
        lines,
      };
    }

    function buildBiweeklyExamples({ referenceDate }) {
      const monthStart = startOfMonth(referenceDate);
      const monthEnd = endOfMonth(referenceDate);

      const run16 = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), 16);
      const p1Start = monthStart;
      const p1End = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), 15);

      const nextMonth1 = new Date(referenceDate.getFullYear(), referenceDate.getMonth() + 1, 1);
      const p2Start = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), 16);
      const p2End = monthEnd;

      return {
        title: `Executa a cada 15 dias. Exemplo:`,
        lines: [
          `Dia ${pad2(run16.getDate())} → Período do dia ${pad2(p1Start.getDate())} ao dia ${pad2(p1End.getDate())}.`,
          `Dia ${pad2(nextMonth1.getDate())} → Período do dia ${pad2(p2Start.getDate())} ao dia ${pad2(p2End.getDate())}.`,
        ],
      };
    }

    function buildMonthlyExamples({ dayOfMonth, referenceDate }) {
      const day = Number(dayOfMonth);
      const runDate = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), day);

      const prevMonthRef = new Date(referenceDate.getFullYear(), referenceDate.getMonth() - 1, 1);
      const pStart = startOfMonth(prevMonthRef);
      const pEnd = endOfMonth(prevMonthRef);

      return {
        title: `Executa no dia ${pad2(day)} de cada mês. Exemplo:`,
        lines: [
          `Dia ${pad2(runDate.getDate())} → Período do dia ${pad2(pStart.getDate())} ao dia ${pad2(pEnd.getDate())} (mês anterior).`,
        ],
      };
    }

    function buildAgendamentoText(agendamento, referenceDate) {

      const periodo = agendamento.periodo_selecionado;
      const dia = agendamento.dia;

      if (periodo === "semanal" && dia) {
        return buildWeeklyExamples({ weekdayName: dia, referenceDate });
      }
      if (periodo === "quinzenal") {
        return buildBiweeklyExamples({ referenceDate });
      }
      if (periodo === "mensal" && dia) {
        return buildMonthlyExamples({ dayOfMonth: dia, referenceDate });
      }

      return { title: "Período inválido.", lines: [] };
    }

    const agendamentoInfo = buildAgendamentoText(this.obs.agendamento, new Date());

    let agendamentos = SefaStore.obs.index_agendamentos?.map(values => {

      return ({
        descricao: values.descricao,
        periodo: values.periodo.toUpperCase(),
        dia: values.periodo == "semanal" ? getDiaSemana(values.dia).toLocaleUpperCase() : values.periodo == "mensal" ? (values.dia || "1") : "",
        itens: values
      })

    })

    function buttonFormatterDetalhesAgend(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleViewDetalhesAgend(row.itens)}
          >
            <img src="/images/edit.png" width="18px" />
          </MDBBtn>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleDeleteAgendamento(row.itens)}
          >
            <img src="/images/bin.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    const handleViewDetalhesAgend = async (row: any) => {

      this.obs.agendamento.periodo_selecionado = row.periodo
      this.obs.agendamento.dia = row.dia
      this.obs.agendamento.listEmpresas = row.empresas
      this.obs.agendamento.descricao = row.descricao
      this.obs.agendamento.id = row._id

      this.obs.open_create_agendamento = true

    };

    const handleDeleteAgendamento = async (row: any) => {

      await SefaStore.handleDeleteAgendamento(row._id)

    };

    return (<>

      <Dialog usePortal={true}
        isOpen={this.props.open}
        onClose={() => this.props.onClose()}
        className="AlertUser modal-agendamento"
      >
        <h2 className="titleSEFAZ">Agendamentos</h2>

        {SefaStore.obs.length_agendamentos == 0 &&
          <MDBRow>
            <MDBCol>
              <MDBBtn
                className="btnDefault btnBuscarNfe" onClick={() => { this.obs.agendamento = newIAgendamento(); this.obs.open_create_agendamento = true }}>
                Criar Agendamento
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        }

        <div style={{ height: 400, overflow: "auto", marginTop: 10 }}>
          <BootstrapTable className="" data={agendamentos}>
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
            <TableHeaderColumn dataField="periodo" width="15%">Período</TableHeaderColumn>
            <TableHeaderColumn dataField="dia" width="15%">Dia</TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterDetalhesAgend} width="15%">Detalhes</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <MDBRow>
          <MDBCol md="8" className="page-sefa">
            <div style={{ marginTop: 5 }}>
              <Pager
                currentPage={SefaStore.obs.page_agendamentos}
                totalCount={SefaStore.obs.length_agendamentos}
                pageSize={5}
                onPageChange={page => this.handlePageAgendamento(SefaStore.obs.page_agendamentos = page)}
              />
            </div>
          </MDBCol>
          <MDBCol md="4">
            <Button text="Fechar" intent="primary" onClick={() => this.props.onClose()} style={{ marginTop: "30px", float: "right" }} />
          </MDBCol>
        </MDBRow>

      </Dialog>

      <Dialog usePortal={true} isOpen={this.obs.open_create_agendamento} onClose={() => this.handleCloseAgendamento()}>
        {this.obs.agendamento.id == ""
          ? <h2 className="titleSEFAZ">Criar Agendamento</h2>
          : <h2 className="titleSEFAZ">Editar Agendamento</h2>
        }

        <FormGroup className="form-group" label="Descrição *">
          <InputGroup type="text" onChange={(e: any) => this.obs.agendamento.descricao = e.target.value} value={this.obs.agendamento.descricao} />
        </FormGroup>

        <div style={{ display: "flex" }}>

          <FormGroup label="Período de comunicação *" style={{ width: ["semanal", "mensal"].includes(this.obs.agendamento.periodo_selecionado) ? "50%" : "100%" }} helperText={
            <>
              {agendamentoInfo.title}
              <br />
              {agendamentoInfo.lines.map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </>
          }>
            <HTMLSelect
              onChange={(e) => {
                this.obs.agendamento.periodo_selecionado = e.target.value
                this.obs.agendamento.dia = ""
              }}
              value={this.obs.agendamento.periodo_selecionado}
            >
              <option disabled value="">Selecione uma opção</option>
              <option value={"semanal"}>Semanal</option>
              <option value={"quinzenal"}>Quinzenal</option>
              <option value={"mensal"}>Mensal</option>
            </HTMLSelect>
          </FormGroup>

          {this.obs.agendamento.periodo_selecionado == "semanal" &&

            <FormGroup label="Selecione dia *" style={{ width: "50%", marginLeft: 10 }}>
              <HTMLSelect onChange={(e) => this.obs.agendamento.dia = e.target.value} value={this.obs.agendamento.dia}>
                <option disabled value={""}>Selecione uma opção</option>
                <option value={"7"}>Domingo</option>
                <option value={"1"}>Segunda-feira</option>
                <option value={"2"}>Terça-feira</option>
                <option value={"3"}>Quarta-feira</option>
                <option value={"4"}>Quinta-feira</option>
                <option value={"5"}>Sexta-feira</option>
                <option value={"6"}>Sábado</option>
              </HTMLSelect>
            </FormGroup>
          }

          {this.obs.agendamento.periodo_selecionado == "mensal" &&
            <FormGroup label="Selecione dia *" style={{ width: "50%", marginLeft: 10 }}>
              <HTMLSelect onChange={(e) => this.obs.agendamento.dia = e.target.value} value={this.obs.agendamento.dia}>
                <option disabled value={""}>Selecione uma opção</option>
                {this.handleDays()}
              </HTMLSelect>
            </FormGroup>
          }
        </div>

        <FormGroup label="Empresas *" style={{ width: "100%" }}>
          <div className="select-empresa-sefa sefa-agendamento">
            <BootstrapTable data={empresas} selectRow={selectRow} options={options_agendamentos} search>
              <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="razao_social" width="75%">Razão Social</TableHeaderColumn>
              <TableHeaderColumn dataField="cnpj_formated" width="20%">CNPJ</TableHeaderColumn>
            </BootstrapTable>
          </div>

        </FormGroup>

        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button text="Cancelar" onClick={() => this.handleCloseAgendamento()} />
          <Button text="Salvar" intent="primary" onClick={() => this.handleCreateAgendamento()} />
        </div>
      </Dialog>

    </>);

  }

}

export default AgendamentoSefa;
